import React ,{createContext , useContext , useState} from "react";

const MyContext = createContext()
 
export const useMyContext = ()=> useContext(MyContext)
export const MyContextProvider = ({children})=>{
    const [cartItem  , setCartItem] = useState([])
    const [qty,setQty]=useState(0); 
    const handleClick = (newValue)=>{
        setQty(newValue)
    }
    const contextCartItem={
        cartItem,
        setCartItem,
        qty,
        handleClick
    };
   
    return <MyContext.Provider value={contextCartItem}>{children}</MyContext.Provider>
}